import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <>
      <section>
        <footer
          className="page-footer font-small indigo d-flex flex-column"
          style={{
            backgroundColor: "rgb(20, 20, 20)",
            bottom: 0,
            position: "relative",
            width: "100%",
          }}
        >
          <br />
          <br />
          <div className="container text-center text-md-left footer">
            <div className="row">
              <div className="col-md-3 mx-auto">
                <img
                  className="mt-3"
                  src="/images/logo.png"
                  style={{ width: "80px" }}
                />
                <p className="mt-2">Hye Hosting LLC.</p>
                <p>File Number 0803730258</p>
              </div>
              <div className="col-md-3 mx-auto">
                <h5 className="mt-3 mb-4 font-weight-bold">Products</h5>
                <ul className="list-unstyled">
                  <li>
                    <Link to="/minecraft">Minecraft</Link>
                  </li>
                  <li>
                    <Link to="#">Discord Bot</Link>
                  </li>
                  <li>
                    <Link to="/n-vps">N-VPS</Link>
                  </li>
                </ul>
              </div>
              <hr className="clearfix w-100 d-md-none" />
              <div className="col-md-3 mx-auto">
                <h5 className="mt-3 mb-4 font-weight-bold">Links</h5>
                <ul className="list-unstyled">
                  <li>
                    <Link to="https://discord.gg/nXeMVBXeps">
                      Discord Server
                    </Link>
                  </li>
                  <li>
                    <Link to="#!">Server Statistics</Link>
                  </li>
                </ul>
              </div>
              <hr className="clearfix w-100 d-md-none" />
              <div className="col-md-3 mx-auto">
                <h5 className="mt-3 mb-4 font-weight-bold">Legal</h5>
                <ul className="list-unstyled">
                  <li>
                    <Link to="/tos">Terms of Service</Link>
                  </li>
                  <li>
                    <Link to="privacy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="https://account.mojang.com/documents/minecraft_eula">
                      Minecraft EULA
                    </Link>
                  </li>
                  <li>
                    <Link to="/abuse">Report System Abuse</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="footer-copyright text-center py-3">
            <p>© 2021 Copyright Hye Hosting LLC. All rights reserved.</p>
          </div>
        </footer>
      </section>
    </>
  );
};

export default Footer;
